var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"\n  bg-white \n  rounded-px \n  py-3\n  px-16 \n  border\n  border-grey-light \n  focus:outline-none \n  focus:bg-white",attrs:{"type":"date","placeholder":_vm.placeholder},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }